/*
 * cart-bubble-state.js
 *
 * Adds .cart-count-bubble--has-items to every cart bubble whose
 * inner [data-cart-count] text resolves to a positive integer.
 * CSS hides bubbles without this class so the dot only appears when
 * the cart is non-empty.
 *
 * Watches the whole body subtree so newly rendered bubbles (sticky
 * header swaps, AJAX cart updates) also get evaluated.
 */
(function () {
  function syncBubbles() {
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    var any = false;
    for (var i = 0; i < bubbles.length; i++) {
      var bubble = bubbles[i];
      var countEl = bubble.querySelector('[data-cart-count]');
      var n = 0;
      if (countEl) {
        var raw = (countEl.textContent || '').trim();
        var parsed = parseInt(raw, 10);
        if (!isNaN(parsed)) n = parsed;
      }
      bubble.classList.toggle('cart-count-bubble--has-items', n > 0);
      if (n > 0) any = true;
    }
    // Mirror the state on <body> so CSS can hide the dot even for bubbles
    // this loop has not reached yet (sticky header swaps, AJAX re-renders).
    // The count lives in the span's TEXT, not in an attribute value, so CSS
    // alone cannot test it - this class is the only reliable signal.
    document.body.classList.toggle('cart-has-items', any);
    document.body.classList.add('cart-bubble-ready');
  }

  var observer = null;
  function startObserver() {
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      syncBubbles();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    syncBubbles();
    startObserver();
    document.addEventListener('shopify:section:load', syncBubbles);
    document.addEventListener('cart:refresh', syncBubbles);
    document.addEventListener('cart:updated', syncBubbles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
